import { render, staticRenderFns } from "./ThemesTable.html?vue&type=template&id=af79c886&"
import script from "./ThemesTable.js?vue&type=script&lang=js&"
export * from "./ThemesTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports